import { useCallback, useEffect, useState } from 'react';

import { getEmployees } from '@/modules/employees/redux/EmployeeCRUD';

import { RequestMaterialEmployeeOption } from '../types';

interface UseRequestMaterialEmployeesParams {
  companyId: string;
  userId?: string;
  skip?: boolean;
  onError?: (message: string) => void;
}

export default function useRequestMaterialEmployees({
  companyId,
  userId = '',
  skip = false,
  onError,
}: UseRequestMaterialEmployeesParams) {
  const [employeeOptions, setEmployeeOptions] = useState<RequestMaterialEmployeeOption[]>([]);
  const [currentEmployeeId, setCurrentEmployeeId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchEmployees = useCallback(async (company: string) => {
    if (!company || company === 'global') {
      setEmployeeOptions([]);
      setCurrentEmployeeId(null);
      return;
    }

    setLoading(true);
    try {
      const response = await getEmployees({ company, status: 'active', page_size: 500 });
      const options: RequestMaterialEmployeeOption[] = (response.data.results || []).map((employee: any) => ({
        id: employee.id,
        name: employee.name,
        nickname: employee.nickname || '',
        avatar: employee.user?.avatar || null,
        image1: employee.image1 || null,
        user_id: String(employee.user?.id || employee.user_id || '').trim() || undefined,
      }));
      setEmployeeOptions(options);

      const currentEmployee = userId
        ? options.find((employee) => employee.user_id === String(userId))
        : null;
      setCurrentEmployeeId(currentEmployee?.id || null);
    } catch (_error) {
      onError?.('Không thể tải danh sách nhân viên.');
      setEmployeeOptions([]);
      setCurrentEmployeeId(null);
    } finally {
      setLoading(false);
    }
  }, [onError, userId]);

  useEffect(() => {
    if (skip || !companyId) return;
    void fetchEmployees(companyId);
  }, [companyId, fetchEmployees, skip]);

  return { employeeOptions, currentEmployeeId, loading };
}